import React from 'react';
import Select from "react-select";
import {Input, Label} from "reactstrap";
import {Glob as G} from "../../libs/Glob.mjs";
import TextLabel from "../../controls/TextLabel.mjs";

const indentOptions = [
	{ value: undefined, label: 'No' },
	{ value: 1, label: '1' },
	{ value: 2, label: '2' },
	{ value: 3, label: '3' },
	{ value: 4, label: '4' },
	{ value: 5, label: '5' }
];

const classNames = [
	{ value: undefined, label: 'Full width' },
	{ value: "col col2", label: "1 column out of 2" },
	{ value: "col col3", label: "1 column out of 3" },
	{ value: "col col3-2", label: "2 columns out of 3" },
];

const depConditionOptions = [
	{ value:undefined, label: 'Not null' },
	{ value: 'value', label: '==' },
	{ value: 'notvalue', label: '<>' }
];

const getDepCondition = d => {
	let v;
	if ( typeof d?.value === 'string' ) v = 'value';
	else if ( typeof d?.notvalue === 'string' ) v = 'notvalue';
	return depConditionOptions.find( o => o.value === v );
}

const EditorSubIndentDepends = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			orig: props.value,
			value: G.clone(props.value),
			classNames: classNames.map( cn => {
				cn.label = G.label(cn.label);
				return cn;
			}),
			depTypes: [
				{ value: undefined, label: G.label('Show') },
				{ value: 'readonly', label: G.label('Lock') }
			]
		};
		this.commit = this.commit.bind(this);
		this.uid = G.generateUid('SubfieldIndentDepends');
	}
	commit(k,v) {
		const s = this.state.value || {};
		if ( typeof v === "undefined" ) {
			delete s[k];
		} else {
			s[k] = v;
		}
		this.setState({ value: s }, ()=>{
			this.props.setValue( k, v );
		})
	}
	render() {
		const depOptions = (this.props.fieldKeys || []).map(k => ({value: k, label: k}));
		return(
			<>
				<div className="fieldRow SubfieldIndent">
					<Label>
						<TextLabel value={"Indent"} />
					</Label>
					<div className={"select selectIndent"}>
						<Select
							options={indentOptions}
							defaultValue={indentOptions.find(x => (x.value === (this.state.value?.indent)))}
							onChange={sv => {
								this.commit('indent', sv.value);
							}}
						/>
					</div>
					<Label>
						<TextLabel value={"View"} />:
					</Label>
					<div
						className={"select"}
						style={{minWidth:"200px"}}
					>
						<Select
							options={ this.state.classNames }
							menuPortalTarget={document.body}
							styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
							value={ this.state.classNames.find( o => o.value === this.state.value?.className ) }
							onChange={ sv => {
								this.commit( 'className', sv.value );
							}}
						/>
					</div>
				</div>
				{  (this.state.value?.depends||[]).concat({}).map( (d,i)=> (
					<div className={"fieldRow SubfieldDepends dep-num-" + i} key={i}>
						<Label>
							<TextLabel value={"Depends"}/>
						</Label>
						<div className={"select selectDepends"}>
							<Select
								isClearable={true}
								placeholder={G.label('Select')}
								options={depOptions}
								defaultValue={d?.on ? {
									label: d.on,
									value: d.on
								} : undefined}
								onChange={sv => {
									let ds = this.state.value.depends || [];
									if (sv?.value) {
										if (typeof ds[i] === 'undefined') ds[i] = {};
										ds[i].on = sv.value;
									} else {
										ds.splice(i, 1);
									}
									this.commit('depends', ds);
								}}
							/>
						</div>
						<Label hidden={!d?.on}>
							<TextLabel value={"If"}/>:
						</Label>
						<div
							hidden={!d?.on}
							className={"select depCondition"}
						>
							<Select
								isDisabled={!d?.on}
								defaultValue={getDepCondition(d)}
								options={depConditionOptions}
								onChange={v => {
									const ds = this.state.value.depends || [];
									if (typeof ds[i] === 'undefined') ds[i] = {};
									if (v.value) {
										if (v.value === 'value') {
											ds[i].value = ds[i]?.value || (this.props.value?.depends || [])[i]?.value || '';
											delete ds[i].notvalue;
										} else if (v.value === 'notvalue') {
											ds[i].notvalue = ds[i]?.notvalue || (this.props.value?.depends || [])[i]?.notvalue || '';
											delete ds[i]?.value;
										}
									} else {
										delete ds[i].value;
										delete ds[i].notvalue;
									}
									this.commit('depends', ds);
								}}
							/>
						</div>
						<Input
							type={"text"}
							style={{ width:"100px", textAlign:"center" }}
							hidden={typeof d?.value !== 'string'}
							defaultValue={d?.value || ''}
							onBlur={e => {
								const ds = this.state.value.depends || [];
								if (typeof ds[i] === 'undefined') ds[i] = {};
								ds[i].value = e.target.value;
								this.commit('depends', ds);
							}}
						/>
						<Input
							type={"text"}
							style={{ width:"100px", textAlign:"center" }}
							hidden={typeof d?.notvalue !== 'string'}
							defaultValue={d?.notvalue || ''}
							onBlur={e => {
								const ds = this.state.value.depends || [];
								if (typeof ds[i] === 'undefined') ds[i] = {};
								ds[i].notvalue = e.target.value;
								this.commit('depends', ds);
							}}
						/>
						<Label hidden={!d?.on}>
							<TextLabel value={"Then"}/>:
						</Label>
						<div hidden={!d?.on}>
							<Select
								options={ this.state.depTypes }
								value={ this.state.depTypes[d.type ? 1 : 0] }
								onChange={ sv => {
									let ds = this.state.value.depends || [];
									if (typeof ds[i] === 'undefined') ds[i] = {};
									if ( sv?.value === 'readonly') {
										ds[i].type = "readonly";
									} else {
										delete ds[i].type;
									}
									this.commit('depends', ds);
								}}
							/>
						</div>
					</div>
				))}
			</>
		)
	}
}

export default EditorSubIndentDepends;